export type FormatoCodigoBarras = 'EAN13' | 'EAN8' | 'CODE128';

export function ean13CheckDigit(twelveDigits: string): string {
  const digits = twelveDigits.split('').map((d) => Number(d));
  let sum = 0;
  for (let i = 0; i < 12; i += 1) {
    sum += digits[i] * (i % 2 === 0 ? 1 : 3);
  }
  return String((10 - (sum % 10)) % 10);
}

export function ean8CheckDigit(sevenDigits: string): string {
  const digits = sevenDigits.split('').map((d) => Number(d));
  let sum = 0;
  for (let i = 0; i < 7; i += 1) {
    sum += digits[i] * (i % 2 === 0 ? 3 : 1);
  }
  return String((10 - (sum % 10)) % 10);
}

export function esEan13Valido(value: string): boolean {
  if (!/^\d{13}$/.test(value)) return false;
  return ean13CheckDigit(value.slice(0, 12)) === value[12];
}

export function esEan8Valido(value: string): boolean {
  if (!/^\d{8}$/.test(value)) return false;
  return ean8CheckDigit(value.slice(0, 7)) === value[7];
}

/** Detecta el formato visual. 13/8 dígitos se tratan como EAN aunque el dígito verificador falle. */
export function detectarFormatoCodigoBarras(value: string): FormatoCodigoBarras {
  const v = value.trim();
  if (/^\d{13}$/.test(v)) return 'EAN13';
  if (/^\d{8}$/.test(v)) return 'EAN8';
  return 'CODE128';
}

export function esCodigoBarrasValidoParaPreview(value: string): boolean {
  const v = value.trim();
  if (!v) return false;
  const formato = detectarFormatoCodigoBarras(v);
  if (formato === 'EAN13') return esEan13Valido(v);
  if (formato === 'EAN8') return esEan8Valido(v);
  return v.length > 0;
}

export function mensajeErrorCodigoBarras(value: string): string | null {
  const v = value.trim();
  if (!v) return null;
  const formato = detectarFormatoCodigoBarras(v);
  if (formato === 'EAN13' && !esEan13Valido(v)) {
    return 'EAN-13 inválido: el dígito verificador no coincide.';
  }
  if (formato === 'EAN8' && !esEan8Valido(v)) {
    return 'EAN-8 inválido: el dígito verificador no coincide.';
  }
  return null;
}

export function etiquetaFormatoCodigoBarras(formato: FormatoCodigoBarras): string {
  if (formato === 'EAN13') return 'EAN-13';
  if (formato === 'EAN8') return 'EAN-8';
  return 'Code 128';
}

/**
 * Genera un código a partir del artículo.
 * Numérico de hasta 12 dígitos → EAN-13 con dígito verificador.
 * Cualquier otro valor → se usa tal cual (Code 128).
 */
export function generarCodigoBarraDesdeArticulo(codigoArticulo: string): string {
  const trimmed = codigoArticulo.trim();
  if (!trimmed) {
    throw new Error('Ingresá el código de artículo primero');
  }
  if (/^\d+$/.test(trimmed) && trimmed.length <= 12) {
    const twelve = trimmed.padStart(12, '0');
    return twelve + ean13CheckDigit(twelve);
  }
  return trimmed;
}

export function jsBarcodeFormat(formato: FormatoCodigoBarras): 'EAN13' | 'EAN8' | 'CODE128' {
  return formato;
}
